import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  page: {
    padding: `0 ${theme.shape.padding}px`,
  },
  row: {
    display: "flex",
  },
  topRowContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.shape.padding,
  },
  sortedDataContainer: {
    flexDirection: "column",
  },
  sortedDataText: {
    margin: 0,
    color: theme.palette.grey[400],
  },
  baseContainer: {
    minHeight: 120,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  findingNumberText: {
    fontSize: 22,
    marginBottom: 0,
    fontWeight: "bold",
  },
  dataTitle: {
    fontSize: 12,
    fontWeight: 500,
    marginBottom: 0,
  },
  dataText: {
    fontSize: 35,
    fontWeight: 400,
    marginBottom: 0,
  },
  rulesContainer: {
    width: "10%",
    display: "flex",
    cursor: "pointer",
    flexDirection: "column",
    padding: theme.shape.padding,
    justifyContent: "space-between",
    marginRight: theme.shape.padding,
  },
  connectorStatusContainer: {
    width: "30%",
    cursor: "pointer",
    padding: theme.shape.padding,
    marginRight: theme.shape.padding,
  },
  status: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: theme.shape.padding,
    "& p": {
      marginBottom: 5,
    },
  },
  statusIcon: {
    marginRight: 10,
  },
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  testRunContainer: {
    width: "20%",
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    "& p": {
      marginBottom: 0,
    },
  },
  reportNumberContainer: {
    height: 100,
    width: "10%",
    display: "flex",
    cursor: "pointer",
    flexDirection: "column",
    padding: theme.shape.padding,
    justifyContent: "space-between",
    marginRight: theme.shape.padding,
  },
  popReportPlaceholder: {
    width: "90%",
    height: 100,
    padding: theme.shape.padding,
  },
  emptyStateContainer: {
    height: 200,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  dialogHeaderContainer: {
    display: "flex",
    paddingRight: 30,
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    padding: theme.shape.padding * 2,
  },
  close: {
    cursor: "pointer",
  },
  sectionTitle: {
    marginBottom: 0,
  },
  list: {
    paddingLeft: theme.shape.padding,
  },
  listItem: {
    marginLeft: theme.shape.padding,
  },
  dialogActions: {
    justifyContent: "flex-start",
    padding: theme.shape.padding * 2,
    paddingTop: 0,
  },
  red: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
  },
}));
